import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';

export const SUPPORTED_LANGUAGES = ['fr', 'en'];
export const DEFAULT_LANGUAGE = 'fr';
export const LANGUAGE_STORAGE_KEY = 'language';

function getInitialLanguage() {
  // 1. Préférence sauvegardée (même principe que le thème, cf. theme/theme.js)
  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (saved && SUPPORTED_LANGUAGES.includes(saved)) return saved;
  // 2. Préférence navigateur
  const browserLanguage = (navigator.language || '').split('-')[0];
  if (SUPPORTED_LANGUAGES.includes(browserLanguage)) return browserLanguage;
  // 3. Repli par défaut
  return DEFAULT_LANGUAGE;
}

const initialLanguage = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false,
    },
  });

document.documentElement.setAttribute('lang', initialLanguage);
localStorage.setItem(LANGUAGE_STORAGE_KEY, initialLanguage);

export default i18n;
